import React, { Fragment as _, useContext } from 'react';
import { Box } from 'theme-ui';
import { AssessmentQuestionContext } from './AssessmentQuestion';
import { interactionContext as InteractionContext } from './interactionContext';
import { colors, getButtonFocus } from 'styles/variables';

const CheckboxRadioBtn = props => {
  const assessmentQuestionContext = useContext<any>(AssessmentQuestionContext);
  const { singleSelect, selected, setSelected } = assessmentQuestionContext;

  // console.log({ singleSelect, selected });

  const { id, color, selectedColor } = props;

  return (
    <Box
      id={`checkbox-radio-${id}`}
      sx={{
        width: 20,
        height: 20,
        background: selected.includes(id) ? selectedColor : color,
        // || color
        borderRadius: singleSelect ? '50%' : 0,
        boxShadow: '0 0 0 1px rgba(0,0,0,0.15)',
        cursor: 'pointer',
        transition: 'background 0.15s',

        ...(window.dev &&
          window.dev() && {
            pointerEvents: 'none',
          }),
      }}
      // onClick={() => {
      //   setSelected(id);
      // }}
    ></Box>
  );
};

// const isOdd =
const AssessmentQuestionOption = ({ children, ...props }) => {
  const assessmentQuestionContext = useContext<any>(AssessmentQuestionContext);
  const interactionContext = useContext<any>(InteractionContext);

  const { setSelected } = assessmentQuestionContext;

  const {
    optionBackgroundColor = 'fff',
    optionCheckboxColor,
    optionCheckboxSelectedColor,
  } = interactionContext.props;

  const { id, qNum, numOptions, index } = props;

  const lastOptionIsOddIndex = index === numOptions - 1 && !!(numOptions % 2);
  let marginX = lastOptionIsOddIndex ? 'noMargin' : index % 2;
  //

  const margin = {
    0: '10px 20px 10px 0',
    1: '10px 0 10px 20px',
    noMargin: '10px 0',
  }[marginX];

  const focus = getButtonFocus(optionBackgroundColor).replace(
    'box-shadow: ',
    ''
  );

  // console.log({ focus });

  return (
    <Box
      className="chameleon-assessment-option"
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 50,
        width: '100%',
        maxWidth: 'calc(50% - 20px)',
        margin,
        padding: '0 0 0 10px',
        background: optionBackgroundColor,
        borderRadius: 10,
        boxShadow: '0px 0px 6px 0px rgba(0,0,0,0.15)',

        '&:focus': {
          boxShadow: focus,
        },

        '@media screen and (max-width: 768px)': {
          maxWidth: '100%',
          margin: '10px 0 !important',
        },
      }}
      tabIndex={0}
      onKeyUp={e => {
        if (!['Enter', ' '].includes(e.key)) {
          return;
        }

        setSelected(id);
      }}
      onClick={() => {
        setSelected(id);
      }}
    >
      <Box
        sx={{
          flex: 1,
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: 50,
        }}
      >
        <CheckboxRadioBtn
          id={id}
          color={!!optionCheckboxColor ? optionCheckboxColor : '#fff'}
          selectedColor={
            !!optionCheckboxSelectedColor ? optionCheckboxSelectedColor : '#000'
          }
        />
      </Box>
    </Box>
  );
};

export default AssessmentQuestionOption;
